// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables used throughout our scss AND bootstrap variables */
.light-gray {
  color: #f3f3f3 !important;
}

.dark-gray {
  color: #4a4a4a !important;
}

.mid-gray {
  color: #dcdcdc !important;
}

.icon-gray {
  color: #9e9fa1 !important;
}

.red {
  color: #da291c !important;
}

.dark-red {
  color: #af2218 !important;
}

.white {
  color: #fff !important;
}

.duckegg-blue {
  color: #e4f4fd !important;
}

.powder-blue {
  color: #deecfd !important;
}

.light-blue {
  color: #35b2e2 !important;
}

.link-blue {
  color: #007bff !important;
}

.blue {
  color: #009cde !important;
}

.dark-blue {
  color: #025a95 !important;
}

.teal {
  color: #01a3b0 !important;
}

.light-yellow {
  color: #fce8b6 !important;
}

.yellow {
  color: #f0b323 !important;
}

.orange {
  color: #df6d00 !important;
}

.green {
  color: #5ba400 !important;
}

.filter-light-gray {
  filter: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg) brightness(109%) contrast(91%);
}

.filter-dark-gray {
  filter: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg) brightness(105%) contrast(70%);
}

.filter-icon-gray {
  filter: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg) brightness(82%) contrast(84%);
}

.filter-mid-gray {
  filter: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg) brightness(99%) contrast(87%);
}

.filter-red {
  filter: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg) brightness(91%) contrast(86%);
}

.filter-dark-red {
  filter: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg) brightness(92%) contrast(108%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.filter-duckegg-blue {
  filter: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg) brightness(103%) contrast(104%);
}

.filter-powder-blue {
  filter: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg) brightness(112%) contrast(98%);
}

.filter-light-blue {
  filter: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg) brightness(90%) contrast(97%);
}

.filter-link-blue {
  filter: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg) brightness(99%) contrast(101%);
}

.filter-blue {
  filter: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg) brightness(101%) contrast(101%);
}

.filter-dark-blue {
  filter: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg) brightness(93%) contrast(98%);
}

.filter-teal {
  filter: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg) brightness(94%) contrast(99%);
}

.filter-light-yellow {
  filter: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg) brightness(129%) contrast(98%);
}

.filter-yellow {
  filter: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg) brightness(106%) contrast(88%);
}

.filter-green {
  filter: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg) brightness(101%) contrast(101%);
}

.filter-orange {
  filter: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg) brightness(97%) contrast(102%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.stroke-dark-blue {
  stroke: #025a95;
}

.transGenHeader .dateField {
  width: 80%;
}
.transGenHeader .dateField .react-datepicker__input-container,
.transGenHeader .dateField .date-picker-icon {
  width: 95%;
  height: 45px;
}
.transGenHeader .weekEndDate .react-datepicker__input-container,
.transGenHeader .weekEndDate .date-picker-icon {
  width: 95%;
  height: 45px;
}
.transGenHeader .uvlSection {
  width: 95%;
  height: 45px;
  padding: 0 10px;
  margin-right: 0;
}
.transGenHeader .tApproverSection {
  width: 95%;
  height: 20%;
}
.transGenHeader .tSheetApprovers__indicator-separator {
  display: none;
}
.transGenHeader .transGenApprover label {
  margin-left: 0;
}
.transGenHeader .transGenApprover select {
  width: 95%;
  height: 45px;
  padding: 0 10px;
}
.transGenHeader .commentSection input {
  width: 95%;
  height: 45px;
  padding: 0 10px;
}

.costApprover .approverLabel {
  margin-left: 0;
  font-weight: bold;
  font-size: 16px;
}
.costApprover label {
  margin-left: 0;
}
.costApprover select {
  width: 95%;
  height: 45px;
  padding: 0 10px;
}

@media all and (max-width: 575px) {
  .uvlEstimate {
    padding-left: 24px;
    padding-bottom: 24px;
  }
}
.uvlEstimate label {
  margin-left: 0;
}
.uvlEstimate input[type=radio] {
  font-size: 18px !important;
  width: 28px;
  height: 28px;
}
.uvlEstimate div {
  margin-bottom: 12px;
}
.uvlEstimate .uvlLabel {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

@media all and (max-width: 575px) {
  .reviewerComment {
    padding-inline: 10px;
  }
}
.reviewerComment .reviewerCommentLabel {
  font-size: 14px;
  font-weight: bold;
}
.reviewerComment input {
  padding: 0 10px;
  height: 45px;
}

.subCircuit {
  width: 154px;
}

.timeSheetSelectField {
  width: 95%;
}

.icons {
  padding: 2px !important;
  cursor: pointer;
}

@media all and (max-width: 575px) {
  form select {
    width: 66%;
    display: flex;
  }
}
form .eqpSelect__menu {
  z-index: 1;
}
form .eqpSelect__input:focus {
  box-shadow: none;
}
form .eqpSelect__control {
  height: 45px;
  width: 210px;
  font-size: 16px;
  border-color: #000;
}
@media all and (max-width: 575px) {
  form .eqpSelect__control {
    width: 66%;
    font-size: 12px;
  }
}
form .eqpSelect__placeholder {
  height: 45px;
  width: 95%;
  font-size: 16px;
  border-color: #000;
}
@media all and (max-width: 575px) {
  form .eqpSelect__placeholder {
    width: 66%;
    font-size: 12px;
  }
}
form .eqpSelect__indicators {
  padding: 0px 0px 0px 4px;
  height: 45px;
}
form .eqpSelect__clear-indicator {
  width: 0px;
}
form .eqpSelect__indicator-separator {
  width: 0px;
}
form .eqpSelect__value-container {
  margin-top: -7px;
}

.classification {
  display: flex;
  width: 100%;
  padding: 0 24px 24px;
  border-radius: 0 0 6px 6px;
}
@media all and (max-width: 575px) {
  .classification {
    padding: 0;
  }
}
.classification .checkDiv {
  margin: 14px 12px 14px 0;
}
.classification .checkDiv input[type=checkbox] {
  width: 24px;
  height: 24px;
}
.classification .formDiv {
  display: flex;
  flex-wrap: wrap;
  width: calc(100vw - 254px);
}
@media all and (max-width: 575px) {
  .classification .formDiv {
    flex-direction: column;
    width: 400px;
  }
}
.classification .formDiv select,
.classification .formDiv input {
  width: 95%;
  height: 45px;
  padding: 0 10px;
  margin-right: 5px;
}

.customEqupId {
  width: 201px !important;
}

.formDivListView {
  display: flex;
  width: 100px;
}
.formDivListView select,
.formDivListView input {
  width: 210px;
  height: 45px;
  padding: 0 10px;
  margin-right: 5px;
}

.classificationContainer {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  margin-bottom: 24px;
}

.serviceTypeDiv {
  display: flex;
  border-bottom: 1px solid #dcdcdc;
  background-color: #f3f3f3;
  padding: 10px;
  margin-bottom: 24px;
}
@media all and (max-width: 575px) {
  .serviceTypeDiv {
    flex-direction: column;
    position: relative;
    margin-bottom: "0px";
  }
}
.serviceTypeDiv label {
  margin: 5px 0;
}
.serviceTypeDiv .serviceTypeSection {
  width: 250px;
}

.distributionAcctHeader label {
  margin-left: 0;
}
.distributionAcctHeader .row1 select,
.distributionAcctHeader .row1 input {
  padding: 0 5px;
}
.distributionAcctHeader .row2 select {
  width: 240px;
  height: 41px;
  padding: 0 5px;
}
.distributionAcctHeader .row2 input {
  width: 150px;
  height: 41px;
  padding: 0 5px;
}

.distributionAccounting div {
  width: 160px;
}
.distributionAccounting label {
  margin: 5px 0;
}
.distributionAccounting input {
  width: 150px;
  height: 41px;
  padding: 0 5px;
}
.distributionAccounting .distWorkOrder input {
  width: 200px;
}

.addBtn {
  padding: 38px 0 24px;
}
.addBtn #addButton {
  margin-left: 36px;
}
.addBtn .btn-link {
  font-size: 16px;
  font-weight: bold;
  color: #025a95;
  text-decoration: none;
}
@media all and (max-width: 575px) {
  .addBtn .btn-link {
    height: 25px;
  }
}
.addBtn .btn-link:hover {
  text-decoration: none;
}

.pdfBtn {
  color: #4a4a4a !important;
  font-size: 16px !important;
  font-weight: 200 !important;
  padding: 0;
}

.errorIcon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.removeFile {
  color: #4a4a4a !important;
}

.addClassification.addBtn {
  padding: 0;
}
@media all and (max-width: 575px) {
  .addClassification.addBtn {
    padding-left: 25px;
  }
}
.addClassification.pdfBtn {
  padding: 0;
}
.addClassification .btn {
  padding-left: 0;
}
@media all and (max-width: 575px) {
  .addClassification {
    width: -moz-fit-content;
    width: fit-content;
  }
}

.serviceType {
  background-color: #f3f3f3;
  width: 240px;
  height: 41px;
  padding: 0 10px;
}
@media all and (max-width: 575px) {
  .serviceType {
    margin-left: 24px;
  }
}

.iconDiv {
  display: flex;
  align-items: center;
  padding-top: 25px;
}
.iconDiv div {
  cursor: pointer;
  margin: 5px;
}
.iconDiv .removeService {
  color: #025a95;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.viewIcon {
  margin-left: auto;
  display: flex;
  padding: 20px;
}

.hideClassifications {
  width: 40px;
  height: 40px;
}
@media all and (max-width: 575px) {
  .hideClassifications {
    width: auto;
    top: 0;
    position: absolute;
    right: 0;
    margin-right: -12px;
  }
}
.hideClassifications div:nth-of-type(1) {
  cursor: pointer;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin: 15px 0 0;
}
@media all and (max-width: 575px) {
  .hideClassifications div:nth-of-type(1) {
    margin-right: 25px;
    margin-top: 1px;
  }
}
.hideClassifications div:nth-of-type(1) button {
  color: #4a4a4a;
  width: 8px;
  height: 8px;
}
.hideClassifications div:nth-of-type(2) {
  cursor: pointer;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin: 15px 0 0;
}
@media all and (max-width: 575px) {
  .hideClassifications div:nth-of-type(2) {
    margin: 35px 10px 0px 0;
  }
}
.hideClassifications div:nth-of-type(2) .sType {
  margin: 0;
  cursor: pointer;
}

.timesheetButtonArea {
  padding: 0;
  background-color: #f5f7f9;
}

.modal-header {
  margin: 24px;
  font-size: 20px;
}

.invoicePreviewModalBody.modal-body {
  padding: 0 !important;
  margin: 24px !important;
}
.invoicePreviewModalBody .aepContainer {
  margin: 0 0 40px 0;
  padding: 0;
}
.invoicePreviewModalBody .lastChild {
  margin-bottom: 0px !important;
  margin-top: 18px !important;
}
.invoicePreviewModalBody .tableTitle {
  font-size: 20px;
}
.invoicePreviewModalBody table {
  margin: 24px 0;
}
.invoicePreviewModalBody .tableFooter {
  background-color: #e4f4fd;
}

.Toastify__toast--success {
  background: #edf2e6 !important;
  color: #367600 !important;
}

.Toastify__toast--error {
  background: #fae1e2 !important;
  color: #da291c !important;
}

.download-timesheet {
  float: right;
  cursor: pointer;
  margin-top: 0.3rem;
}

@media all and (max-width: 575px) {
  .card {
    width: 66%;
    margin-left: 28px;
    margin-top: 24px;
    border: none;
  }
}

@media all and (max-width: 575px) {
  .serviceTypeHolder {
    height: 420px;
    padding-top: 14px;
    width: 360px;
  }
}

.serviceTypeHolderGridView {
  overflow-y: scroll;
  max-height: 500px;
  width: calc(100vw - 8px);
}

.serviceTypeHolderListView {
  max-height: 500px;
  overflow-x: scroll;
  width: calc(100vw - 93px);
}

@media all and (max-width: 575px) {
  .carousel {
    background-color: white;
    height: -moz-fit-content;
    height: fit-content;
    margin: 0;
    max-height: -moz-fit-content;
    max-height: fit-content;
  }
}

@media all and (max-width: 575px) {
  .carousel-control-prev,
  .carousel-control-next {
    height: 20px;
    width: 71%;
    margin-left: -100px;
    text-align: center;
    color: #000;
  }
}

@media all and (max-width: 575px) {
  .carousel-control-prev .eqpSelect__single-value {
    margin: top -10px;
  }
}

.form-control,
input {
  width: 95%;
  height: 45px;
}

@media all and (max-width: 575px) {
  .carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}

@media all and (max-width: 575px) {
  .carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

@media all and (max-width: 575px) {
  .carousel-control-prev:hover,
  .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #000;
  }
}

.tSheetApprovers__control,
.tSheetApprovers__value-container,
.tSheetApprovers__option {
  width: 328px;
  height: 52px;
}

.tSheetApprovers__input-container {
  width: 328px;
  height: 52px;
  margin-bottom: 0 !important;
}

.tSheetApprovers__indicator-container {
  display: none;
}

.transAccounting .headerContainer {
  margin: 0 0 10px 0;
}
@media all and (max-width: 575px) {
  .transAccounting .headerContainer {
    margin: 0 0 10px 5px;
  }
}
.transAccounting label {
  margin: 0 0 5px 0;
}
.transAccounting .checkWOSection {
  display: flex;
}
@media all and (max-width: 575px) {
  .transAccounting .checkWOSection {
    margin-left: 15px;
  }
}
.transAccounting .checkWOSection .checkWOButton {
  width: 100px;
  padding: 0;
  margin: 30px 10px;
}
.transAccounting .transAccountingFields {
  display: flex;
}
.transAccounting .transAccountingFields .checkWOSection button {
  width: 94px;
  height: 32px;
}

.timesheetPreviewDialog {
  width: 50%;
}

.leftRightArrow {
  display: flex;
  flex-direction: row;
  position: relative;
  top: 35%;
}

@media all and (max-width: 575px) {
  .addClassificationSection {
    padding-inline: 10px;
  }
}

.disEqRentalUnitStyle > input {
  border: solid green;
}

.timesheetStatusHistoryTable th, .timesheetStatusHistoryTable td {
  font-size: 16px;
  padding: 10px;
  border: 1px solid #ddd;
}`, "",{"version":3,"sources":["webpack://./src/lib/styles/scss/variables/_vars-colors.scss","webpack://./src/pages/Timesheet/TimesheetEntry/TimesheetEntry.scss"],"names":[],"mappings":"AAAC,+DAAA;AAqHD;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,sBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADuHA;EACE,8FA1HkB;ACMpB;;ADuHA;EACE,6FA5HiB;ACQnB;;ADuHA;EACE,4FA9HiB;ACUnB;;ADuHA;EACE,0FAhIgB;ACYlB;;ADuHA;EACE,+FAjIW;ACab;;ADuHA;EACE,gGAnIgB;ACelB;;ADuHA;EACE,6FAtGa;ACdf;;ADuHA;EACE,+FArIoB;ACiBtB;;ADuHA;EACE,+FAvImB;ACmBrB;;ADuHA;EACE,+FAzIkB;ACqBpB;;ADsHA;EACE,gGAtIiB;ACmBnB;;ADqHA;EACE,iGA7IY;AC2Bd;;ADqHA;EACE,+FA/IiB;AC6BnB;;ADqHA;EACE,+FA9IY;AC4Bd;;ADqHA;EACE,gGA/IoB;AC6BtB;;ADqHA;EACE,6FAjJc;AC+BhB;;ADqHA;EACE,gGAlJa;ACgCf;;ADqHA;EACE,+FAnJc;ACiChB;;ADoHA;EACE,6FAnJa;ACkCf;;ADoHA;EACE,eAzOU;ACwHZ;;AApJE;EACE,UAAA;AAuJJ;AAtJI;;EAEE,UAAA;EACA,YAAA;AAwJN;AAnJI;;EAEE,UAAA;EACA,YAAA;AAqJN;AAjJE;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAmJJ;AAhJE;EACE,UAAA;EACA,WAAA;AAkJJ;AA/IE;EACE,aAAA;AAiJJ;AA7II;EACE,cAAA;AA+IN;AA7II;EACE,UAAA;EACA,YAAA;EACA,eAAA;AA+IN;AA1II;EACE,UAAA;EACA,YAAA;EACA,eAAA;AA4IN;;AAtIE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAyIJ;AAvIE;EACE,cAAA;AAyIJ;AAvIE;EACE,UAAA;EACA,YAAA;EACA,eAAA;AAyIJ;;AApIE;EADF;IAEI,kBAAA;IACA,oBAAA;EAwIF;AACF;AAtIE;EACE,cAAA;AAwIJ;AArIE;EACE,0BAAA;EACA,WAAA;EACA,YAAA;AAuIJ;AApIE;EACE,mBAAA;AAsIJ;AAnIE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAqIJ;;AAhIE;EADF;IAEI,oBAAA;EAoIF;AACF;AAnIE;EACE,eAAA;EACA,iBAAA;AAqIJ;AAnIE;EACE,eAAA;EACA,YAAA;AAqIJ;;AAjIA;EACE,YAAA;AAoIF;;AAjIA;EACE,UAAA;AAoIF;;AAjIA;EACE,uBAAA;EACA,eAAA;AAoIF;;AA/HI;EADF;IAEI,UAAA;IACA,aAAA;EAmIJ;AACF;AAjIE;EACE,UAAA;AAmIJ;AAjIE;EACE,gBAAA;AAmIJ;AAjIE;EAKE,YAAA;EACA,YAAA;EAEA,eAAA;EACA,kBD3HI;ACyPR;AAtII;EADF;IAEI,UAAA;IACA,eAAA;EAyIJ;AACF;AAlIE;EAKE,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBDrII;ACqQR;AAvII;EADF;IAEI,UAAA;IACA,eAAA;EA0IJ;AACF;AApIE;EACE,wBAAA;EACA,YAAA;AAsIJ;AAnIE;EACE,UAAA;AAqIJ;AAnIE;EACE,UAAA;AAqIJ;AAlIE;EACE,gBAAA;AAoIJ;;AAhIA;EAKE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;AA+HF;AAtIE;EADF;IAEI,UAAA;EAyIF;AACF;AAlIE;EACE,wBAAA;AAoIJ;AAlII;EACE,WAAA;EACA,YAAA;AAoIN;AAhIE;EAcE,aAAA;EACA,eAAA;EAEA,0BAAA;AAoHJ;AApII;EADF;IAEI,sBAAA;IACA,YAAA;EAuIJ;AACF;AArII;;EAEE,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAuIN;;AA7HA;EACE,uBAAA;AAgIF;;AA7HA;EAQE,aAAA;EACA,YAAA;AAyHF;AAjIE;;EAEE,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAmIJ;;AA7HA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAgIF;;AA7HA;EAaE,aAAA;EACA,gCAAA;EACA,yBDzPS;EC0PT,aAAA;EACA,mBAAA;AAoHF;AApIE;EADF;IAEI,sBAAA;IACA,kBAAA;IACA,oBAAA;EAuIF;AACF;AAtIE;EACE,aAAA;AAwIJ;AAtIE;EACE,YAAA;AAwIJ;;AA7HE;EACE,cAAA;AAgIJ;AA7HI;;EAEE,cAAA;AA+HN;AA3HI;EACE,YAAA;EACA,YAAA;EACA,cAAA;AA6HN;AA3HI;EACE,YAAA;EACA,YAAA;EACA,cAAA;AA6HN;;AAvHE;EACE,YAAA;AA0HJ;AAxHE;EACE,aAAA;AA0HJ;AAxHE;EACE,YAAA;EACA,YAAA;EACA,cAAA;AA0HJ;AAvHI;EACE,YAAA;AAyHN;;AApHA;EACE,oBAAA;AAuHF;AArHE;EACE,iBAAA;AAuHJ;AApHE;EAIE,eAAA;EACA,iBAAA;EACA,cD5RQ;EC6RR,qBAAA;AAmHJ;AAzHI;EADF;IAEI,YAAA;EA4HJ;AACF;AArHE;EACE,qBAAA;AAuHJ;;AAnHA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,UAAA;AAsHF;;AAnHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAsHF;;AAnHA;EACE,yBAAA;AAsHF;;AAlHE;EAKE,UAAA;AAiHJ;AArHI;EADF;IAEI,kBAAA;EAwHJ;AACF;AAnHE;EACE,UAAA;AAqHJ;AAnHE;EACE,eAAA;AAqHJ;AAlHE;EAhBF;IAiBI,uBAAA;IAAA,kBAAA;EAqHF;AACF;;AAlHA;EAKE,yBD1WS;EC2WT,YAAA;EACA,YAAA;EACA,eAAA;AAiHF;AAxHE;EADF;IAEI,iBAAA;EA2HF;AACF;;AAnHA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAsHF;AArHE;EACE,eAAA;EACA,WAAA;AAuHJ;AArHE;EACE,cD/VQ;ECgWR,eAAA;EACA,yCAAA;EACA,iBAAA;AAuHJ;;AAnHA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;AAsHF;;AAnHA;EAUE,WAAA;EACA,YAAA;AA6GF;AAvHE;EADF;IAEI,WAAA;IACA,MAAA;IACA,kBAAA;IACA,QAAA;IACA,mBAAA;EA0HF;AACF;AApHE;EAKE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAkHJ;AA1HI;EADF;IAEI,kBAAA;IACA,eAAA;EA6HJ;AACF;AAtHI;EACE,cD1ZK;EC2ZL,UAAA;EACA,WAAA;AAwHN;AApHE;EAKE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAkHJ;AA1HI;EADF;IAEI,uBAAA;EA6HJ;AACF;AArHI;EACE,SAAA;EACA,eAAA;AAuHN;;AAlHA;EACE,UAAA;EACA,yBDtbS;AC2iBX;;AAlHA;EACE,YAAA;EACA,eAAA;AAqHF;;AAjHE;EACE,qBAAA;EACA,uBAAA;AAoHJ;AAlHE;EACE,kBAAA;EACA,UAAA;AAoHJ;AA/GE;EACE,6BAAA;EACA,2BAAA;AAiHJ;AA/GE;EACE,eAAA;AAiHJ;AA/GE;EACE,cAAA;AAiHJ;AA/GE;EACE,yBDlcW;ACmjBf;;AA7GA;EACE,8BAAA;EACA,yBAAA;AAgHF;;AA7GA;EACE,8BAAA;EACA,yBAAA;AAgHF;;AA9GA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAiHF;;AA7GE;EADF;IAEI,UAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;EAiHF;AACF;;AA7GE;EADF;IAEI,aAAA;IACA,iBAAA;IACA,YAAA;EAiHF;AACF;;AA9GA;EACE,kBAAA;EACA,iBAAA;EACA,wBAAA;AAiHF;;AA9GA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;AAiHF;;AA7GE;EADF;IAEI,uBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,SAAA;IACA,4BAAA;IAAA,uBAAA;EAiHF;AACF;;AA5GE;EAFF;;IAGI,YAAA;IACA,UAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;EAiHF;AACF;;AA5GI;EADF;IAEI,iBAAA;EAgHJ;AACF;;AA5GA;;EAEE,UAAA;EACA,YAAA;AA+GF;;AA3GE;EADF;IAEI,yDAAA;EA+GF;AACF;;AA3GE;EADF;IAEI,yDAAA;EA+GF;AACF;;AAxGE;EAJF;;;;IAKI,WAAA;EA+GF;AACF;;AA5GA;;;EAGE,YAAA;EACA,YAAA;AA+GF;;AA5GA;EACE,YAAA;EACA,YAAA;EACA,2BAAA;AA+GF;;AA5GA;EACE,aAAA;AA+GF;;AA3GE;EAIE,kBAAA;AA2GJ;AA9GI;EADF;IAEI,oBAAA;EAiHJ;AACF;AA7GE;EACE,iBAAA;AA+GJ;AA5GE;EACE,aAAA;AA8GJ;AA7GI;EAFF;IAGI,iBAAA;EAgHJ;AACF;AA/GI;EACE,YAAA;EACA,UAAA;EACA,iBAAA;AAiHN;AA7GE;EACE,aAAA;AA+GJ;AA7GM;EACE,WAAA;EACA,YAAA;AA+GR;;AAzGA;EACE,UAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AA4GF;;AAxGE;EADF;IAEI,oBAAA;EA4GF;AACF;;AA1GA;EACE,mBAAA;AA6GF;;AAzGE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AA4GJ","sourcesContent":["﻿/* variables used throughout our scss AND bootstrap variables */\n\n//----------------------------------------------\n// COLORS\n//----------------------------------------------\n$gray-100: #f3f3f3;\n$gray-200: #eceff3;\n$gray-300: #dcdcdc;\n$gray-400: #f5f7f9;\n$gray-600: #9e9fa1;\n$gray-900: #4a4a4a;\n\n$darker-gray:#e2e6ea;\n$dark-gray: $gray-900;\n$icon-gray: $gray-600;\n$mid-gray: $gray-300;\n$lighter-gray: $gray-400;\n$fade-gray: $gray-200;\n$light-gray: $gray-100;\n\n$red: #da291c;\n$light-red: #fae1e2;\n$dark-red: #af2218;\n\n$white: #fff;\n$black: #000;\n\n$duckegg-blue: #e4f4fd;\n$powder-blue: #deecfd;\n$light-blue: #35b2e2;\n$blue: #009cde;\n$dark-blue: #025a95;\n$darker-blue: #1f74b9;\n$link-blue: #007bff;\n$link-hover: #0056b3;\n$faint-blue: #d0ecf8;\n\n$teal: #01a3b0;\n\n$light-yellow: #fce8b6;\n$yellow: #f0b323;\n\n$green: #5ba400;\n$dark-green: #367600;\n$light-green: #edf2e6;\n\n$light-orange: #fcebd2;\n$orange: #df6d00;\n\n$svg-colors: (\n  'icon-gray': $icon-gray,\n  'dark-gray': $dark-gray,\n  'red': $red,\n  'dark-red': $dark-red,\n  'blue': $blue,\n  'dark-blue': $dark-blue,\n  'link-blue': $link-blue,\n  'duckegg-blue': $duckegg-blue,\n  'green': $green,\n  'orange': $orange,\n  'teal': $teal,\n  'yellow': $yellow,\n  'white': $white,\n);\n\n//----------------------------------------------\n// FILTER COLORS\n//----------------------------------------------\n$filter-class: '';\n$filter-light-gray: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg)\n  brightness(109%) contrast(91%);\n$filter-dark-gray: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg)\n  brightness(105%) contrast(70%);\n$filter-icon-gray: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg)\n  brightness(82%) contrast(84%);\n$filter-mid-gray: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg)\n  brightness(99%) contrast(87%);\n\n$filter-red: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg)\n  brightness(91%) contrast(86%);\n$filter-dark-red: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg)\n  brightness(92%) contrast(108%);\n\n$filter-white: invert(98%) sepia(100%) saturate(0%) hue-rotate(301deg)\n  brightness(102%) contrast(101%);\n\n$filter-duckegg-blue: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg)\n  brightness(103%) contrast(104%);\n$filter-powder-blue: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg)\n  brightness(112%) contrast(98%);\n$filter-light-blue: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg)\n  brightness(90%) contrast(97%);\n$filter-blue: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg)\n  brightness(101%) contrast(101%);\n$filter-dark-blue: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg)\n  brightness(93%) contrast(98%);\n$filter-link-blue: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg)\n  brightness(99%) contrast(101%);\n\n$filter-teal: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg)\n  brightness(94%) contrast(99%);\n\n$filter-light-yellow: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg)\n  brightness(129%) contrast(98%);\n$filter-yellow: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg)\n  brightness(106%) contrast(88%);\n\n$filter-green: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg)\n  brightness(101%) contrast(101%);\n\n$filter-orange: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg)\n  brightness(97%) contrast(102%);\n\n$filter-white: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)\n  brightness(103%) contrast(103%);\n\n// COLOR CLASSES\n.light-gray {\n  color: $light-gray !important;\n}\n\n.dark-gray {\n  color: $dark-gray !important;\n}\n\n.mid-gray {\n  color: $mid-gray !important;\n}\n\n.icon-gray {\n  color: $icon-gray !important;\n}\n\n.red {\n  color: $red !important;\n}\n\n.dark-red {\n  color: $dark-red !important;\n}\n\n.white {\n  color: $white !important;\n}\n\n.duckegg-blue {\n  color: $duckegg-blue !important;\n}\n\n.powder-blue {\n  color: $powder-blue !important;\n}\n\n.light-blue {\n  color: $light-blue !important;\n}\n\n.link-blue {\n  color: $link-blue !important;\n}\n\n.blue {\n  color: $blue !important;\n}\n\n.dark-blue {\n  color: $dark-blue !important;\n}\n\n.teal {\n  color: $teal !important;\n}\n\n.light-yellow {\n  color: $light-yellow !important;\n}\n\n.yellow {\n  color: $yellow !important;\n}\n\n.orange {\n  color: $orange !important;\n}\n\n.green {\n  color: $green !important;\n}\n\n// FILTER CLASSES\n.filter-light-gray {\n  filter: $filter-light-gray;\n}\n\n.filter-dark-gray {\n  filter: $filter-dark-gray;\n}\n\n.filter-icon-gray {\n  filter: $filter-icon-gray;\n}\n\n.filter-mid-gray {\n  filter: $filter-mid-gray;\n}\n\n.filter-red {\n  filter: $filter-red;\n}\n\n.filter-dark-red {\n  filter: $filter-dark-red;\n}\n\n.filter-white {\n  filter: $filter-white;\n}\n\n.filter-duckegg-blue {\n  filter: $filter-duckegg-blue;\n}\n\n.filter-powder-blue {\n  filter: $filter-powder-blue;\n}\n\n.filter-light-blue {\n  filter: $filter-light-blue;\n}\n.filter-link-blue {\n  filter: $filter-link-blue;\n}\n.filter-blue {\n  filter: $filter-blue;\n}\n\n.filter-dark-blue {\n  filter: $filter-dark-blue;\n}\n\n.filter-teal {\n  filter: $filter-teal;\n}\n\n.filter-light-yellow {\n  filter: $filter-light-yellow;\n}\n\n.filter-yellow {\n  filter: $filter-yellow;\n}\n\n.filter-green {\n  filter: $filter-green;\n}\n\n.filter-orange {\n  filter: $filter-orange;\n}\n.filter-white {\n  filter: $filter-white;\n}\n\n.stroke-dark-blue {\n  stroke: $dark-blue;\n}\n","@import 'lib/styles/scss/variables/_vars-colors.scss';\n\n.transGenHeader {\n  .dateField {\n    width: 80%;\n    .react-datepicker__input-container,\n    .date-picker-icon {\n      width: 95%;\n      height: 45px;\n    }\n  }\n\n  .weekEndDate {\n    .react-datepicker__input-container,\n    .date-picker-icon {\n      width: 95%;\n      height: 45px;\n    }\n  }\n\n  .uvlSection {\n    width: 95%;\n    height: 45px;\n    padding: 0 10px;\n    margin-right: 0;\n  }\n\n  .tApproverSection {\n    width: 95%;\n    height: 20%;\n  }\n\n  .tSheetApprovers__indicator-separator {\n    display: none;\n  }\n\n  .transGenApprover {\n    label {\n      margin-left: 0;\n    }\n    select {\n      width: 95%;\n      height: 45px;\n      padding: 0 10px;\n    }\n  }\n\n  .commentSection {\n    input {\n      width: 95%;\n      height: 45px;\n      padding: 0 10px;\n    }\n  }\n}\n\n.costApprover {\n  .approverLabel {\n    margin-left: 0;\n    font-weight: bold;\n    font-size: 16px;\n  }\n  label {\n    margin-left: 0;\n  }\n  select {\n    width: 95%;\n    height: 45px;\n    padding: 0 10px;\n  }\n}\n\n.uvlEstimate {\n  @media all and (max-width: '575px') {\n    padding-left: 24px;\n    padding-bottom: 24px;\n  }\n\n  label {\n    margin-left: 0;\n  }\n\n  input[type='radio'] {\n    font-size: 18px !important;\n    width: 28px;\n    height: 28px;\n  }\n\n  div {\n    margin-bottom: 12px;\n  }\n\n  .uvlLabel {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 12px;\n  }\n}\n\n.reviewerComment {\n  @media all and (max-width: '575px') {\n    padding-inline: 10px;\n  }\n  .reviewerCommentLabel {\n    font-size: 14px;\n    font-weight: bold;\n  }\n  input {\n    padding: 0 10px;\n    height: 45px;\n  }\n}\n\n.subCircuit {\n  width: 154px;\n}\n\n.timeSheetSelectField {\n  width: 95%;\n}\n\n.icons {\n  padding: 2px !important;\n  cursor: pointer;\n}\n\nform {\n  select {\n    @media all and (max-width: '575px') {\n      width: 66%;\n      display: flex;\n    }\n  }\n  .eqpSelect__menu {\n    z-index: 1;\n  }\n  .eqpSelect__input:focus {\n    box-shadow: none;\n  }\n  .eqpSelect__control {\n    @media all and (max-width: '575px') {\n      width: 66%;\n      font-size: 12px;\n    }\n    height: 45px;\n    width: 210px;\n\n    font-size: 16px;\n    border-color: $black;\n  }\n  .eqpSelect__placeholder {\n    @media all and (max-width: '575px') {\n      width: 66%;\n      font-size: 12px;\n    }\n    height: 45px;\n    width: 95%;\n    font-size: 16px;\n    border-color: $black;\n  }\n  .eqpSelect__indicators {\n    padding: 0px 0px 0px 4px;\n    height: 45px;\n  }\n\n  .eqpSelect__clear-indicator {\n    width: 0px;\n  }\n  .eqpSelect__indicator-separator {\n    width: 0px;\n  }\n\n  .eqpSelect__value-container {\n    margin-top: -7px;\n  }\n}\n\n.classification {\n  @media all and (max-width: '575px') {\n    padding: 0;\n  }\n\n  display: flex;\n  width: 100%;\n  padding: 0 24px 24px;\n  border-radius: 0 0 6px 6px;\n\n  .checkDiv {\n    margin: 14px 12px 14px 0;\n\n    input[type='checkbox'] {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .formDiv {\n    @media all and (max-width: '575px') {\n      flex-direction: column;\n      width: 400px;\n    }\n\n    select,\n    input {\n      width: 95%;\n      height: 45px;\n      padding: 0 10px;\n      margin-right: 5px;\n    }\n\n    display: flex;\n    flex-wrap: wrap;\n\n    width: calc(100vw - 254px);\n  }\n}\n\n.customEqupId {\n  width: 201px !important;\n}\n\n.formDivListView {\n  select,\n  input {\n    width: 210px;\n    height: 45px;\n    padding: 0 10px;\n    margin-right: 5px;\n  }\n  display: flex;\n  width: 100px;\n}\n\n.classificationContainer {\n  border: 1px solid $mid-gray;\n  border-radius: 6px;\n  margin-bottom: 24px;\n}\n\n.serviceTypeDiv {\n  @media all and (max-width: '575px') {\n    flex-direction: column;\n    position: relative;\n    margin-bottom: '0px';\n  }\n  label {\n    margin: 5px 0;\n  }\n  .serviceTypeSection {\n    width: 250px;\n  }\n\n  display: flex;\n  border-bottom: 1px solid $mid-gray;\n  background-color: $light-gray;\n  padding: 10px;\n  margin-bottom: 24px;\n}\n\n.distributionAcctHeader {\n  label {\n    margin-left: 0;\n  }\n  .row1 {\n    select,\n    input {\n      padding: 0 5px;\n    }\n  }\n  .row2 {\n    select {\n      width: 240px;\n      height: 41px;\n      padding: 0 5px;\n    }\n    input {\n      width: 150px;\n      height: 41px;\n      padding: 0 5px;\n    }\n  }\n}\n\n.distributionAccounting {\n  div {\n    width: 160px;\n  }\n  label {\n    margin: 5px 0;\n  }\n  input {\n    width: 150px;\n    height: 41px;\n    padding: 0 5px;\n  }\n  .distWorkOrder {\n    input {\n      width: 200px;\n    }\n  }\n}\n\n.addBtn {\n  padding: 38px 0 24px;\n\n  #addButton {\n    margin-left: 36px;\n  }\n\n  .btn-link {\n    @media all and (max-width: '575px') {\n      height: 25px;\n    }\n    font-size: 16px;\n    font-weight: bold;\n    color: $dark-blue;\n    text-decoration: none;\n  }\n\n  .btn-link:hover {\n    text-decoration: none;\n  }\n}\n\n.pdfBtn {\n  color: $dark-gray !important;\n  font-size: 16px !important;\n  font-weight: 200 !important;\n  padding: 0;\n}\n\n.errorIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n\n.removeFile {\n  color: $dark-gray !important ;\n}\n\n.addClassification {\n  &.addBtn {\n    @media all and (max-width: '575px') {\n      padding-left: 25px;\n    }\n\n    padding: 0;\n  }\n\n  &.pdfBtn {\n    padding: 0;\n  }\n  .btn {\n    padding-left: 0;\n  }\n\n  @media all and (max-width: '575px') {\n    width: fit-content;\n  }\n}\n\n.serviceType {\n  @media all and (max-width: '575px') {\n    margin-left: 24px;\n  }\n\n  background-color: $light-gray;\n  width: 240px;\n  height: 41px;\n  padding: 0 10px;\n}\n\n.iconDiv {\n  display: flex;\n  align-items: center;\n  padding-top: 25px;\n  div {\n    cursor: pointer;\n    margin: 5px;\n  }\n  .removeService {\n    color: $dark-blue;\n    font-size: 14px;\n    font-family: Arial, Helvetica, sans-serif;\n    font-weight: bold;\n  }\n}\n\n.viewIcon {\n  margin-left: auto;\n  display: flex;\n  padding: 20px;\n}\n\n.hideClassifications {\n  @media all and (max-width: '575px') {\n    width: auto;\n    top: 0;\n    position: absolute;\n    right: 0;\n    margin-right: -12px;\n  }\n\n  // margin-right: 60px;\n  width: 40px;\n  height: 40px;\n\n  div:nth-of-type(1) {\n    @media all and (max-width: '575px') {\n      margin-right: 25px;\n      margin-top: 1px;\n    }\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    vertical-align: middle;\n    margin: 15px 0 0;\n\n    button {\n      color: $dark-gray;\n      width: 8px;\n      height: 8px;\n    }\n  }\n\n  div:nth-of-type(2) {\n    @media all and (max-width: '575px') {\n      margin: 35px 10px 0px 0;\n    }\n\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    vertical-align: middle;\n    margin: 15px 0 0;\n\n    .sType {\n      margin: 0;\n      cursor: pointer;\n    }\n  }\n}\n\n.timesheetButtonArea {\n  padding: 0;\n  background-color: $lighter-gray;\n}\n\n.modal-header {\n  margin: 24px;\n  font-size: 20px;\n}\n\n.invoicePreviewModalBody {\n  &.modal-body {\n    padding: 0 !important;\n    margin: 24px !important;\n  }\n  .aepContainer {\n    margin: 0 0 40px 0;\n    padding: 0;\n  }\n  // .row {\n  //   margin-bottom: 40px !important;\n  // }\n  .lastChild {\n    margin-bottom: 0px !important;\n    margin-top: 18px !important;\n  }\n  .tableTitle {\n    font-size: 20px;\n  }\n  table {\n    margin: 24px 0;\n  }\n  .tableFooter {\n    background-color: $duckegg-blue;\n  }\n}\n\n.Toastify__toast--success {\n  background: $light-green !important;\n  color: $dark-green !important;\n}\n\n.Toastify__toast--error {\n  background: $light-red !important;\n  color: $red !important;\n}\n.download-timesheet {\n  float: right;\n  cursor: pointer;\n  margin-top: 0.3rem;\n}\n\n.card {\n  @media all and (max-width: '575px') {\n    width: 66%;\n    margin-left: 28px;\n    margin-top: 24px;\n    border: none;\n  }\n}\n\n.serviceTypeHolder {\n  @media all and (max-width: '575px') {\n    height: 420px;\n    padding-top: 14px;\n    width: 360px;\n  }\n}\n\n.serviceTypeHolderGridView {\n  overflow-y: scroll;\n  max-height: 500px;\n  width: calc(100vw - 8px);\n}\n\n.serviceTypeHolderListView {\n  max-height: 500px;\n  overflow-x: scroll;\n  width: calc(100vw - 93px);\n}\n\n.carousel {\n  @media all and (max-width: '575px') {\n    background-color: white;\n    height: fit-content;\n    margin: 0;\n    max-height: fit-content;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  @media all and (max-width: '575px') {\n    height: 20px;\n    width: 71%;\n    margin-left: -100px;\n    text-align: center;\n    color: #000;\n  }\n}\n\n.carousel-control-prev {\n  .eqpSelect__single-value {\n    @media all and (max-width: '575px') {\n      margin: top -10px;\n    }\n  }\n}\n\n.form-control,\ninput {\n  width: 95%;\n  height: 45px;\n}\n\n.carousel-control-prev-icon {\n  @media all and (max-width: '575px') {\n    background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e');\n  }\n}\n\n.carousel-control-next-icon {\n  @media all and (max-width: '575px') {\n    background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e');\n  }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  @media all and (max-width: '575px') {\n    color: #000;\n  }\n}\n\n.tSheetApprovers__control,\n.tSheetApprovers__value-container,\n.tSheetApprovers__option {\n  width: 328px;\n  height: 52px;\n}\n\n.tSheetApprovers__input-container {\n  width: 328px;\n  height: 52px;\n  margin-bottom: 0 !important;\n}\n\n.tSheetApprovers__indicator-container {\n  display: none;\n}\n\n.transAccounting {\n  .headerContainer {\n    @media all and (max-width: '575px') {\n      margin: 0 0 10px 5px;\n    }\n    margin: 0 0 10px 0;\n  }\n\n  label {\n    margin: 0 0 5px 0;\n  }\n\n  .checkWOSection {\n    display: flex;\n    @media all and (max-width: '575px') {\n      margin-left: 15px;\n    }\n    .checkWOButton {\n      width: 100px;\n      padding: 0;\n      margin: 30px 10px;\n    }\n  }\n\n  .transAccountingFields {\n    display: flex;\n    .checkWOSection {\n      button {\n        width: 94px;\n        height: 32px;\n      }\n    }\n  }\n}\n\n.timesheetPreviewDialog {\n  width: 50%;\n}\n\n.leftRightArrow {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  top: 35%;\n}\n\n.addClassificationSection {\n  @media all and (max-width: '575px') {\n    padding-inline: 10px;\n  }\n}\n.disEqRentalUnitStyle > input {\n  border: solid green;\n}\n\n.timesheetStatusHistoryTable {\n  th, td {\n    font-size: 16px; // Adjust the size as needed\n    padding: 10px;\n    border: 1px solid #ddd;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
